module.exports = __webpack_public_path__ + "assets/b334583065a43cf6d37c554cb77e0205.png";